module.exports = __webpack_public_path__ + "img/conejo.7f2f99fa.png";